import Vue from 'vue';
import VueCookie from 'vue-cookies';
import { clientService } from '../network/services/client.service';
import parseApiError from "../helpers/api-error-parser";
import {ResponseError} from "../network/response/response-error";

Vue.use(VueCookie);
Vue.$cookies.config('30d');

export default {
  namespaced: true,
  state: {
    auth: false,
    loading: false,
    modalLoading: false,
    loginErrors: {
      password: false,
      email: false
    },
    tokens: {
      accessToken: Vue.$cookies.get('accessToken'),
      refreshToken: Vue.$cookies.get('refreshToken'),
    },
    client: {
      id: null,
      title: null,
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      type: 'client',
    },
  },
  mutations: {
    SET_LOGIN_ERRORS (state, payload) {
      state.loginErrors = payload;
    },
    LOGOUT(state) {
      Vue.$cookies.remove('accessToken');
      Vue.$cookies.remove('refreshToken');
      state.auth = false;
      state.loading = false;
      state.tokens = {
        accessToken: null,
        refreshToken: null,
      };
      state.client = {
        id: null,
        title: null,
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
      };
    },
    SET_AUTH(state, payload) {
      state.auth = !!payload;
    },
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
    SET_MODAL_LOADING(state, payload) {
      state.modalLoading = !!payload;
    },
    SET_TOKENS (state, {accessToken, refreshToken, rememberMe}) {
      state.tokens.accessToken = accessToken;
      state.tokens.refreshToken = refreshToken;
      if (rememberMe) {
        Vue.$cookies.set('accessToken', accessToken, '30d');
        Vue.$cookies.set('refreshToken', refreshToken, '30d');
      }
    },
    SET_CLIENT_ID(state, id) {
      state.client.id = id;
    },
    SET_CLIENT_NAME(state, { firstName, lastName, phone, title, email, type }) {
      state.client.firstName = firstName;
      state.client.lastName = lastName;
      state.client.phone = phone;
      state.client.title = title;
      state.client.email = email;
      state.client.type = type;
    },
  },
  actions: {
    async init(context) {
      if (!context.state.tokens || !context.state.tokens.refreshToken || !context.state.tokens.accessToken) {
        return;
      }
      context.commit('SET_LOADING', true);
      try {
        let tokens = await clientService.refresh(context.state.tokens.accessToken, context.state.tokens.refreshToken, (e) => {
          context.commit('LOGOUT');
          context.commit('SET_LOADING', false);
        });
        if (!tokens || tokens instanceof Error || tokens.error === true) {
          context.commit('LOGOUT');
          context.commit('SET_LOADING', false);
          return tokens.response;
        }
        context.commit('SET_TOKENS', { accessToken: tokens.data.access_token, refreshToken: tokens.data.refresh_token, rememberMe: true });
      } catch (e) {
        console.warn({e})
      }

      return this.dispatch('client/profile', null, { root: true });
    },
    async profile(context) {
      if (!context.state.tokens.accessToken) return;
      context.commit('SET_LOADING', true);
      const response = await clientService.getName(context.state.tokens.accessToken);
      const id = response.get('id', null);
      const name = response.get('Auth', null);
      if (!(id instanceof ResponseError)) {
        context.commit('SET_CLIENT_ID', id);
        context.commit('SET_AUTH', true);
      } else {
        //TODO catch errors
      }
      if (!(name instanceof ResponseError)) {
        context.commit('SET_CLIENT_NAME', name);
      } else {
        //TODO catch errors
      }
      context.commit('SET_LOADING', false);
    },
    async updateProfile(context, data) {
      if (!context.state.tokens.accessToken) return;
      context.commit('SET_MODAL_LOADING', true);
      const response = await clientService.updateProfile(context.state.tokens.accessToken, data);
      const updated = response.get('Auth.update.updated', false);
      context.commit('SET_MODAL_LOADING', false);
      if (updated instanceof ResponseError) {
        // TODO catch errors
      }
      if (updated === false) {
        // TODO catch errors
      }
      return null;
    },
    async connect (context, {email, password, rememberMe}) {
      context.commit('SET_LOADING', true);
      const tokens = await clientService.login(email, password);
      if (tokens.error) {
        context.commit('SET_LOGIN_ERRORS', {
          password: tokens.error_code === 'password_error',
          email: tokens.error_code === 'email_not_found',
        })
        context.commit('LOGOUT');
        context.commit('SET_LOADING', false);
        return tokens.response;
      }
      context.commit('SET_TOKENS', {accessToken: tokens.data.access_token, refreshToken: tokens.data.refresh_token, rememberMe});
      return this.dispatch('client/profile', null, {root: true});
    },
    async logout(context) {
      context.commit('LOGOUT');
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/client.store.js